// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
import React, {useEffect} from 'react';

import {useApolloClient, useSelector} from '../../state/hooks';
import * as ViewSelectors from '../../state/views/selectors';
import {LoadableView} from '../../state/views/types';
import {DraftReportWarningModal} from './DraftReportWarningModal';
import {useNavigateToNewDraft, useViewDraft} from './hooks';

type EditReportTriggerProps = {
  view: LoadableView;
  entityName: string;
  projectName?: string;
  onClick?: () => void;
  onModalClose: () => void;
  setIsLoading: (isLoading: boolean) => void;
};

// This is the wrapper used when user clicks on the "Edit report" menu item in a report page view mode
export const EditReportTrigger = ({
  view,
  entityName,
  projectName,
  onModalClose,
  setIsLoading,
}: EditReportTriggerProps) => {
  const client = useApolloClient();
  const views = useSelector(ViewSelectors.getViews);

  const navigateToNewDraft = useNavigateToNewDraft({
    view,
    views,
    entityName,
    projectName,
  });
  const {draft, isViewDraftsQueryLoading} = useViewDraft({
    viewId: view.id ?? '',
  });

  useEffect(() => {
    if (!isViewDraftsQueryLoading && draft == null) {
      // If no warning modals are needed, redirect to new draft page
      navigateToNewDraft();
      setIsLoading(false);
    }
  }, [draft, isViewDraftsQueryLoading, navigateToNewDraft, setIsLoading]);

  if (isViewDraftsQueryLoading) {
    return null;
  }

  if (view.partRef == null) {
    toast('Error occurred. Please refresh and try again.');
    return null;
  }

  if (draft != null) {
    return (
      <DraftReportWarningModal
        client={client}
        view={view}
        views={views}
        entityName={entityName}
        projectName={projectName}
        draft={draft}
        onModalClose={onModalClose}
      />
    );
  }

  return null;
};
